export default __webpack_public_path__ + "static/media/34I-18662_-14536_0.aff85f7c.jpg";